import React from 'react';
import dynamic from 'next/dynamic';
import {useRouter} from 'next/router';

const LessonPage = dynamic(() => import('../../../../js/pages/LessonPage'), {ssr: false});

const TrackCourseLessonPage = () => {
  const router = useRouter();
  const {
    courseOrTrack: track,
    courseOrLesson: course,
    lesson,
  } = router.query;

  return (
    <LessonPage
      lessonSlug={lesson}
      courseSlug={course}
      trackSlug={track}
    />
  );
};

TrackCourseLessonPage.getLayout = (page) => page;

export default TrackCourseLessonPage;
